
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IUser } from '@/types/types';

@Component({ name: 'ProfileMenu' })
export default class ProfileMenu extends Vue {
  @Prop({ type: Object, default: null }) user!: IUser;
  /* the owning v-menu's open state, so the tab resets on every close */
  @Prop({ type: Boolean, default: false }) open!: boolean;

  menuTab: 'account' | 'help' = 'account';
  photoFailed = false;

  get hasPhoto(): boolean {
    return !!(this.user && this.user.photo) && !this.photoFailed;
  }

  /* the parent owns the v-menu, so it decides how to close it */
  @Emit('close')
  navigateTo(name: string): void {
    this.$router.push({ name }).catch(() => ({}));
  }

  @Watch('open')
  onOpenChange(isOpen: boolean): void {
    if (!isOpen) {
      this.menuTab = 'account';
    }
  }

  logOut(): void {
    this.$store.dispatch('auth/logOut', null);
  }
}
